interface FormatResponse {
  formattedValue: string;
  originalValue: string;
}

export const formatValue = (input: string, template: string, patternChar: string): FormatResponse => {
  if (!input || input.length <= 0) {
    return { formattedValue: '', originalValue: '' };
  }

  const inputChars = input.split('');

  let index = 0;
  const result = template.split('').reduce(
    (acc: FormatResponse, tchar: any) => {
      if (input.length > index) {
        const ichar = inputChars[index];

        if (tchar === ichar) {
          acc.formattedValue = `${acc.formattedValue}${ichar}`;
          index += 1;
        } else if (tchar === patternChar) {
          acc.originalValue = `${acc.originalValue}${ichar}`;
          acc.formattedValue = `${acc.formattedValue}${ichar}`;
          index += 1;
        } else {
          acc.formattedValue = `${acc.formattedValue}${tchar}`;
        }
      }
      return acc;
    },
    {
      formattedValue: '',
      originalValue: '',
    }
  );

  return result;
};
